import { memo } from "react"
import { Box, Stack, Typography } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faChevronDown } from "@fortawesome/pro-light-svg-icons"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    row: {
        gridColumn: "1 / -1",
        width: "100%",
        padding: ".625rem 0",
        background: theme.palette.tailwind.slate[100],
        border: "none",
        borderBottom: `1px solid ${theme.palette.tailwind.gray[200]}`,
        font: "inherit",
        textAlign: "left",
        cursor: "pointer",
    },
    stickyContent: {
        position: "sticky",
        left: 0,
        width: "fit-content",
        padding: "0 1rem",
    },
    name: {
        fontWeight: 700,
        color: theme.palette.text.primary,
        textTransform: "uppercase",
        whiteSpace: "nowrap",
    },
    caret: {
        color: theme.palette.tailwind.slate[500],
        transition: theme.transitions.create("transform", {
            duration: theme.transitions.duration.shortest,
        }),
        "& svg": {
            fontSize: ".875rem",
        },
    },
    caretCollapsed: {
        transform: "rotate(-90deg)",
    },
    description: {
        color: theme.palette.text.secondary,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
}))

type Props = Readonly<{
    name: string
    dishNames: ReadonlyArray<string>
    isCollapsed: boolean
    onToggle: () => void
}>

export const WeekCategoryRow = memo(function WeekCategoryRow({ name, dishNames, isCollapsed, onToggle }: Props) {
    const { classes, cx } = useStyles()

    return (
        <Box component="button" type="button" aria-expanded={!isCollapsed} className={classes.row} onClick={onToggle}>
            <Stack
                component="span"
                direction="row"
                alignItems="center"
                spacing=".5rem"
                className={classes.stickyContent}
            >
                <Stack component="span" className={cx(classes.caret, isCollapsed && classes.caretCollapsed)}>
                    <FontAwesomeIcon icon={faChevronDown} />
                </Stack>
                <Typography variant="subtitle2" className={classes.name}>
                    {name}
                </Typography>
                {dishNames.length > 0 && (
                    <Typography variant="caption" className={classes.description}>
                        {dishNames.join(", ")}
                    </Typography>
                )}
            </Stack>
        </Box>
    )
})
